/**
 * A component that does not render
 * @returns {null}
 *
 */
const Nothing = () => null

export default Nothing
